import AnalyticsObject from '@/docs-partials/api/schema/analytics-object.mdx';
import * as React from 'react';
export default {
  AnalyticsObject,
  React
};